module.exports = __webpack_public_path__ + "img/261.7fe5f220.png";